//
//
//
//
//
//
//
//
//
//
//

import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "InlineLoader",
  props: {
    width: {
      type: String,
      default: "18px"
    },
    height: {
      type: String,
      default: "18px"
    },
    variant: {
      type: String,
      default: "primary"
    }
  },
  computed: {
    loaderClasses() {
      return `text-${this.variant}`;
    },
    loaderStyles() {
      return `width: ${this.width} !important; height: ${this.height} !important;`;
    }
  }
});